module.exports = __webpack_public_path__ + "img/vip_gift_bg.6f9efef5.png";